import { forwardRef, useMemo } from 'react';
import type { CSSProperties } from 'react';

import NextLink from 'next/link';

import { RouteLinkProps } from '../core';

type NextRouteLinkProps = Omit<RouteLinkProps, 'href'> & {
  href: string;
};

export const RouteLink = forwardRef<HTMLAnchorElement, NextRouteLinkProps>(
  function RouteLink(
    { children, locale, routerDirection, routerAction, href, ...rest },
    ref
  ) {
    const nextLocale = useMemo(() => locale && locale.split('-')[0], [locale]);

    const target =
      href?.startsWith('http') &&
      !href.includes(process.env.NEXT_PUBLIC_OLD_WEB_URL as string)
        ? '_blank'
        : '_self';

    return (
      <NextLink
        ref={ref}
        prefetch={false}
        href={href}
        locale={nextLocale}
        target={target}
        draggable={false}
        style={{ userSelect: 'none', WebkitUserDrag: 'none' } as CSSProperties}
        {...rest}
      >
        {children}
      </NextLink>
    );
  }
);
